<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import ButtonGroup from 'dashboard/components-next/buttonGroup/ButtonGroup.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { computed } from 'vue';
// [PROSPEK] 2026-06-01 FEATURE_FLAGS/currentAccountId/isFeatureEnabledonAccount unused (copilot hidden)
// import { FEATURE_FLAGS } from 'dashboard/featureFlags';
// import { useMapGetter } from 'dashboard/composables/store';
// [/PROSPEK]
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';

const { updateUISettings } = useUISettings();

// [PROSPEK] 2026-06-01 Hide Captain/Copilot panel toggle button (enterprise feature)
// const currentAccountId = useMapGetter('getCurrentAccountId');
// const isFeatureEnabledonAccount = useMapGetter('accounts/isFeatureEnabledonAccount');
// const showCopilotTab = computed(() =>
//   isFeatureEnabledonAccount.value(currentAccountId.value, FEATURE_FLAGS.CAPTAIN)
// );
// [/PROSPEK]

const { uiSettings } = useUISettings();
const isContactSidebarOpen = computed(
  () => uiSettings.value.is_contact_sidebar_open
);
// [PROSPEK] 2026-06-01
// const isCopilotPanelOpen = computed(
//   () => uiSettings.value.is_copilot_panel_open
// );
// [/PROSPEK]

const handleConversationSidebarToggle = () => {
  updateUISettings({
    is_contact_sidebar_open: !isContactSidebarOpen.value,
    is_copilot_panel_open: false,
  });
};

// [PROSPEK] 2026-06-01
// const handleCopilotSidebarToggle = () => {
//   updateUISettings({
//     is_contact_sidebar_open: false,
//     is_copilot_panel_open: true,
//   });
// };
// [/PROSPEK]

const keyboardEvents = {
  'Alt+KeyO': {
    action: handleConversationSidebarToggle,
  },
};
useKeyboardEvents(keyboardEvents);
</script>

<template>
  <ButtonGroup
    class="flex flex-col justify-center items-center absolute top-36 xl:top-24 ltr:right-2 rtl:left-2 bg-n-solid-2/90 backdrop-blur-lg border border-n-weak/50 rounded-full gap-1.5 p-1.5 shadow-sm transition-shadow duration-200 hover:shadow !z-20"
  >
    <Button
      v-tooltip.top="$t('CONVERSATION.SIDEBAR.CONTACT')"
      ghost
      slate
      sm
      class="!rounded-full transition-all duration-[250ms] ease-out active:!scale-95 active:!brightness-105 active:duration-75"
      :class="{
        'bg-n-alpha-2 active:shadow-sm': isContactSidebarOpen,
      }"
      icon="i-ph-user-bold"
      @click="handleConversationSidebarToggle"
    />
    <!-- [PROSPEK] 2026-06-01 Hide Captain/Copilot panel toggle button (enterprise feature)
    <Button
      v-if="showCopilotTab"
      v-tooltip.bottom="$t('CONVERSATION.SIDEBAR.COPILOT')"
      ghost
      slate
      sm
      class="!rounded-full transition-all duration-[250ms] ease-out active:!scale-95 active:duration-75"
      :class="{
        'bg-n-alpha-2 !text-n-iris-9 active:!brightness-105 active:shadow-sm':
          isCopilotPanelOpen,
      }"
      icon="i-woot-captain"
      @click="handleCopilotSidebarToggle"
    />
    [/PROSPEK] -->
  </ButtonGroup>
</template>
